const { matchPath } = require('react-router-dom');

function getCurrentRouteName({ path, routes, channel }) {
  const keys = Object.keys(routes);

  for (let i = 0; i < keys.length; i += 1) {
    let key = keys[i];
    let route = routes[key];
    if (matchPath(path, { path: route.path, strict: false })) {
      if (route.channel && route.channel === channel) return route.name;
      if (!route.channel) return route.name;
    }
  }

  return null;
}

function createPrefetchTag(url) {
  if (url.split('.').slice(-1)[0] !== 'js') return;

  const linkTag = document.createElement('link');
  linkTag.rel = 'prefetch';
  linkTag.href = url;
  linkTag.as = 'script';
  document.head.appendChild(linkTag);
}

async function addPrefetchTagsToHead({ currentRouteName, routes, asyncChunks, channel } = {}) {
  // eslint-disable-next-line no-new
  new Promise((resolve) => {
    const addedToHead = [];

    Object
      .keys(routes)
      .filter((routeKey) => {
        const route = routes[routeKey];
        if (route.name === currentRouteName) return false;
        if (route.channel && route.channel !== channel) return false;
        return true;
      })
      .map((routeKey) => {
        const routeName = routes[routeKey].name;

        if (addedToHead[routeName]) return null;
        addedToHead[routeName] = true;

        asyncChunks[routeName].map(createPrefetchTag);

        return null;
      });
    resolve();
  });
}

async function initAsyncRouting({ currentRouteName, routes, asyncChunks, channel } = {}) {
  const currentRouteKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const currentRoute = routes[currentRouteKey];
  const componentModule = await currentRoute.chunk();

  addPrefetchTagsToHead({ currentRouteName, routes, asyncChunks, channel });

  return componentModule[currentRoute.componentName];
}

module.exports = {
  getCurrentRouteName,
  initAsyncRouting
};
